import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/privacyPolicy/PrivacyPolicy.jsx");
